module.exports = __webpack_public_path__ + "img/洛丽碎片1.c219ffcb.png";